import { render, staticRenderFns } from "./VocalAudiometryForm.vue?vue&type=template&id=67586b3b"
import script from "./VocalAudiometryForm.vue?vue&type=script&lang=js"
export * from "./VocalAudiometryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports